import ResizeObserver from 'resize-observer-polyfill';
import useResizeObserver from 'use-resize-observer';

// Polyfill for ResizeObserver
if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

export default useResizeObserver;
